"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.xstate = exports.IMPLICIT_DONE_STATE = exports.IMPLICIT_ERROR_STATE = exports.BOOTSTRAP_EVENT = exports.BOOTSTRAP_STATE = void 0;
const lodash_1 = require("lodash");
exports.BOOTSTRAP_STATE = '__BOOTSTRAP__';
exports.BOOTSTRAP_EVENT = '__BOOTSTRAP_EVENT__';
exports.IMPLICIT_ERROR_STATE = '__IMPLICIT_ERROR__';
exports.IMPLICIT_DONE_STATE = '__IMPLICIT_DONE__';
const xstate = (pageflow) => {
    const states = (0, lodash_1.keys)(pageflow.states).reduce((states, key) => (Object.assign(Object.assign({}, states), { [key]: convert(key, pageflow.states[key]) })), {});
    const xstate = {
        initial: exports.BOOTSTRAP_STATE,
        states: Object.assign({ [exports.BOOTSTRAP_STATE]: {
                on: { [exports.BOOTSTRAP_EVENT]: { target: pageflow.initial } },
            }, [exports.IMPLICIT_DONE_STATE]: final(exports.IMPLICIT_DONE_STATE, {
                type: 'final',
                output: '$.input'
            }), [exports.IMPLICIT_ERROR_STATE]: error(exports.IMPLICIT_ERROR_STATE, {
                type: 'error',
                output: '$.input'
            }) }, states)
    };
    return clean(xstate);
};
exports.xstate = xstate;
const convert = (name, state, renderOnly = false) => {
    const { type } = state;
    switch (type) {
        case 'flow':
            return flow(name, state);
        case 'wait':
            return call(name, state);
        case 'transient':
            return call(name, state);
        case 'error':
            return error(name, state);
        case 'final':
            return final(name, state);
        case 'raw':
            return raw(name, state);
        case 'choice':
            return choice(name, state);
        default:
            throw new Error(`Unknown state type: ${type}`);
    }
};
const call = (name, state) => (state.call || !(0, lodash_1.isEmpty)(state.on))
    ? {
        meta: {
            call: state.call || 'noop://',
            input: state.input,
            output: state.output,
            context: state.context,
            sensitive: state.sensitive,
            description: state.description,
            wait: state.type == 'wait' ? true : undefined,
        },
        on: on(name, state),
        invoke: invoke(name, state)
    }
    : final(name, state);
const flow = (name, state) => ({
    meta: {
        call: state.call || 'noop://',
        input: state.input,
        output: state.output,
        context: state.context,
        sensitive: state.sensitive,
        description: state.description,
        flow: true,
        wait: true
    },
    on: {
        'flow.event': name
    },
    invoke: invoke(name, state, 'flow')
});
const error = (name, state) => ({
    type: state.recoverable ? undefined : 'final',
    meta: {
        input: state.input,
        output: state.output || '$.input',
        context: state.context,
        sensitive: state.sensitive,
        description: state.description,
        error: true,
        recoverable: state.recoverable
    },
    on: on(name, state)
});
const raw = (name, state) => (Object.assign({}, state.data));
const final = (name, state) => ({
    type: 'final',
    meta: {
        sensitive: state.sensitive,
        description: state.description,
        output: state.output
    }
});
const choice = (name, state) => ({
    entry: 'choice',
    on: {
        'CHOICE': [
            ...(state.choices.map((_a) => {
                var { next } = _a, rule = __rest(_a, ["next"]);
                return ({
                    target: next,
                    cond: { type: 'choice', rule }
                });
            })),
            {
                target: state.default
            }
        ]
    }
});
const on = (name, state) => {
    var on = state.on;
    if (on) {
        on = (0, lodash_1.omit)(on, ['done', 'error']);
    }
    on = (0, lodash_1.keys)(on).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [(0, lodash_1.toLower)(key)]: state.call ? { target: on[key], actions: actions(name, state) } : on[key] })), {});
    return (0, lodash_1.keys)(on).length > 0 ? on : undefined;
};
const invoke = (name, state, cond = undefined) => ({
    src: 'call',
    onDone: {
        target: (0, lodash_1.get)(state, 'on.done') ||
            (state.type == 'wait' ? undefined : exports.IMPLICIT_DONE_STATE),
        actions: actions(name, state),
        cond
    },
    onError: (0, lodash_1.get)(state, 'on.error') ||
        (state.type == 'wait' ? undefined : exports.IMPLICIT_ERROR_STATE),
});
const actions = (name, state) => [(0, lodash_1.get)(state, 'context') ? 'appendToContext' : undefined].filter((item) => item);
const clean = (obj) => {
    var t = obj;
    for (var v in t) {
        if (typeof t[v] == 'object') {
            clean(t[v]);
            if ((0, lodash_1.keys)(t[v]).length == 0) {
                delete t[v];
            }
        }
        else if (t[v] == undefined) {
            delete t[v];
        }
    }
    return t;
};
//# sourceMappingURL=transform.js.map